import { Grid, TextField } from '@material-ui/core';
import { useFormikContext } from 'formik';
import * as Yup from 'yup';
import insuranceLogo from '_assets/register/insurance-logo.svg';
import DocumentCard from '../DocumentCard';
import moment from 'moment';

/**
 * Returns the insurance fields initial values, based on the company
 * @param company
 * @returns {{insuranceNumber: string, insuranceExpirationDate: Date, insuranceName: string}}
 */
export function insuranceFieldsInitialValues(company) {
  return {
    insuranceName: company?.insurance_name ?? '',
    insuranceNumber: company?.insurance_number ?? '',
    insuranceValidityDate: company?.insurance_validity_date
      ? moment(company?.insurance_validity_date).format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD'),
  };
}

export const insuranceValidationSchema = Yup.object({
  insuranceName: Yup.string().required('Champ obligatoire'),
  insuranceNumber: Yup.string().required('Champ obligatoire'),
  insuranceValidityDate: Yup.date()
    .typeError('Veuillez saisir une date')
    .min(new Date(), "La date d'expiration ne peut pas être passée.")
    .required('Champ obligatoire'),
});

export default function InsuranceFields({ document, onDocumentChange, isEditing }) {
  const { errors, handleChange, initialValues, touched, values } = useFormikContext();

  return (
    <>
      <Grid container item xs={12} spacing={3}>
        <Grid item xs={12}>
          <TextField
            disabled={!isEditing}
            error={touched.insuranceName && Boolean(errors.insuranceName)}
            helperText={touched.insuranceName && errors.insuranceName}
            fullWidth
            label="Nom de votre assurance"
            name="insuranceName"
            onChange={handleChange}
            value={values.insuranceName}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            disabled={!isEditing}
            error={touched.insuranceNumber && Boolean(errors.insuranceNumber)}
            helperText={touched.insuranceNumber && errors.insuranceNumber}
            fullWidth
            label="Numéro de police"
            name="insuranceNumber"
            onChange={handleChange}
            value={values.insuranceNumber}
            variant="outlined"
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            disabled={!isEditing}
            error={touched.insuranceValidityDate && Boolean(errors.insuranceValidityDate)}
            helperText={touched.insuranceValidityDate && errors.insuranceValidityDate}
            fullWidth
            label="Date d'expiration"
            name="insuranceValidityDate"
            onChange={handleChange}
            type="date"
            value={values.insuranceValidityDate}
            variant="outlined"
            inputProps={{ min: moment().format('YYYY-MM-DD') }}
          />
        </Grid>
      </Grid>

      <Grid container item xs={12} alignItems="flex-end" justifyContent="center" style={{ marginTop: '16px' }}>
        <DocumentCard
          disabled={!isEditing && !initialValues.insuranceName && !initialValues.insuranceNumber}
          document={document}
          logo={insuranceLogo}
          name="Assurance"
          onChange={onDocumentChange}
        />
      </Grid>
    </>
  );
}
